(function () {
  function optionNames(product) {
    return product.options.map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function selectedOptions(container, names) {
    var selected = {};
    names.forEach(function (name) {
      var inputs = container.querySelectorAll('input[type="radio"]');
      Array.prototype.some.call(inputs, function (input) {
        if (input.name === name && input.checked) {
          selected[name] = input.value;
          return true;
        }
        return false;
      });
    });
    return selected;
  }

  function matchingVariant(variants, names, selected) {
    return variants.find(function (variant) {
      return names.every(function (name, index) {
        return variant.options[index] === selected[name];
      });
    });
  }

  function formatMoney(cents) {
    return 'Rs. ' + (cents / 100).toFixed(2);
  }

  function update(container) {
    var product = container._variantPriceProduct;
    if (!product) return;

    var names = optionNames(product);
    var selected = selectedOptions(container, names);

    container.querySelectorAll('.variant-option-price').forEach(function (span) {
      var test = Object.assign({}, selected);
      test[span.dataset.optionName] = span.dataset.optionValue;
      var variant = matchingVariant(product.variants, names, test);
      if (!variant) return;

      span.textContent = formatMoney(variant.price);
      span.classList.toggle('variant-option-price--unavailable', !variant.available);
    });
  }

  function init(container) {
    if (container.dataset.variantPricesInitialized === 'true') {
      update(container);
      return;
    }

    var productUrl = container.dataset.url;
    if (!productUrl) return;
    container.dataset.variantPricesInitialized = 'true';

    fetch(productUrl + '.js')
      .then(function (response) { return response.json(); })
      .then(function (product) {
        container._variantPriceProduct = product;
        update(container);
      })
      .catch(function (error) {
        container.dataset.variantPricesInitialized = 'false';
        console.error('Variant price error:', error);
      });

    container.addEventListener('change', function () {
      window.setTimeout(function () { update(container); }, 0);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('high-variant-selects').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
